import React from 'react';
import { api } from '../../../../api';
import { notifySuccess, notifyError } from '../../../Notification';
import { fetchUsers } from '../../../../redux/usersSlice';
import { useDispatch } from 'react-redux';

const DeleteBusinessModal = ({ email, first_name, business_id, business_name, onClose }) => {
    console.log(`email: ${email}, business_id: ${business_id}`);
    const dispatch = useDispatch();
    
    const handleDelete = async () => {
        try {
            const response = await api.delete('/users-businesses', {
              data: { email, business_id }
            });
            
            console.log('Business deleted successfully');
            notifySuccess(`Business ${business_name} deleted successfully`);
            // fetch users again
            dispatch(fetchUsers(email));
          } catch (error) {
            console.error('Error deleting business:', error.response ? error.response.statusText : error.message);
            notifyError(error.response?.statusText || error.message || `Error deleting business ${business_name}`);
          }
          
    };

    return (
        
            <div >
                <div className='delete-user-business-warning-text'>Are you sure you want to detatch business {business_name} from user {first_name}?</div>
                <div className='delete-users-business-buttons-container'>
                  <button className='delete-user-business-delete-btn' onClick={handleDelete}>Delete</button>
                  <button className='delete-user-business-cancel-btn' onClick={onClose}>Cancel</button>
                </div>
            </div>
       
    );
};

export default DeleteBusinessModal;